import styled from 'styled-components';

export const Div = styled.div<{ $cssStyle?: string }>`
  display: flex;
  align-items: center;

  .nd-title {
    margin-left: 8px;
    font-weight: 500;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .nd-title {
      margin-left: 6px;
    }
    svg {
      width: 16px;
      height: 16px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    .nd-title {
      margin-left: 4px;
    }
    svg {
      width: 14px;
      height: 14px;
    }
  }
  ${({ $cssStyle }) => $cssStyle}
`;
